export const containerStyle = {
    width: "100%",
    height: "70vh",
    position: "relative",
};

export const hoverItemStyle = {
    background: "#5a1335",
    color: "white",
    borderRadius: "4px",
    padding: "6px 10px",
    whiteSpace: "normal",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    maxWidth: "300px",
    minWidth: "200px",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    height: "fit-content",
    minHeight: "50px",
    opacity: "90%",
    fontSize: 14,
    fontWeight: "light",
    transform: "translate(30%, -100%)",
};

export const getAreaAnnotationStyle = (borderColor) => {
    return {
        position: "absolute",
        background: "#F0F0F0",
        border: "4px solid" + borderColor,
        borderRadius: "50%",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "32px",
        height: "32px",
        fontSize: "10px",
        fontWeight: "bold",
    };
};

export const getLineAnnotationStyle = (borderColor) =>{
    return {
        position: "absolute",
        background: "#F0F0F0",
        border: "4px solid " + borderColor,
        borderRadius: "50%",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "32px",
        height: "32px",
        fontSize: "10px",
        fontWeight: "bold",
    };
};

export const getItemStyle = (backgroundColor) => {
    return {
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: backgroundColor,
        marginRight: "6px",
    };
};

export const getPinAnnotationStyle = {
    background: "transparent",
    color: "black",
    fontWeight: "bold",
    fontSize: "10px",
    width: "20px",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    top: "-10px",
    left: "-10px",
    textAlign: "center",
    userSelect: "none",
    pointerEvents: "none",
};

export const currentLocationButtonStyle = {
    position: "absolute",
    top: "40px",
    right: "5px",
    zIndex: 5,
    border: "none",
    backgroundColor: "white",
    padding: "4px",
    width: "20",
    height: "20",
    cursor: "pointer",
    fontSize: "15px",
    color: "black",
};

export const baseButtonStyle = {
    position: "absolute",
    left: "8px",
    padding: "0px 3px",
    width: "75px",
    backgroundColor: "white",
    color: "black",
    height: "30px",
    cursor: "pointer",
    borderRadius: "15px",
    borderColor: "black",
    fontSize: "12px",
    outline: "3px solid white",
};

export const baseInputStyle = {
    marginRight: "2px",
    verticalAlign: "middle",
    fontSize: "10px",
};

export const locationLabelStyle = {
    fontSize: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

export const locationInputStyle = {
    marginRight: "5px",
    transform: "scale(1.2)",
    verticalAlign: "middle",
};

export const locationButtonStyle = {
    ...baseButtonStyle,
    bottom: "1px",
    left: "5px",
    width: "80px",
};

export const dragPinButtonStyle = {
    ...baseButtonStyle,
    bottom: "1px",
    left: "90px",
};

export const hideAllButtonStyle = {
    ...baseButtonStyle,
    bottom: "1px",
    left: "170px",
    width: "70px",
};

export const currentAreaAndDistanceStyle = {
    position: "absolute",
    bottom: "1px",
    left: "245px",
    zIndex: 1,
    backgroundColor: "white",
    color: "darkblue",
    padding: "0 5px",
    borderRadius: "15px",
    fontSize: "12px",
    border: "3px solid darkgreen",
    outline: "3px solid white",
};

export const cancelButtonStyle = {
    ...baseButtonStyle,
    top: "10px",
    left: "5px",
};

export const undoButtonStyle = {
    ...baseButtonStyle,
    "top": "10px",
    "left": "85px",
};

export const saveButtonStyle = {
    ...baseButtonStyle,
    "top": "10px",
    "left": "165px",
};

export const LineIcon = {
    path: "M -2,0 0,2 2,0 0,-2 -2,0",
    fillColor: "white",
    strokeOpacity: 1,
    scale: 2,
    strokeWeight: 1,
    fillOpacity: 1,
    strokeColor: "red",
};

export const LineCrosshairInnerIcon = {
    path: "M -2,0 0,2 2,0 0,-2 -2,0",
    fillColor: "white",
    strokeOpacity: 1,
    scale: 2,
    strokeWeight: 2,
    fillOpacity: 1,
    strokeColor: "green",
};

export const AreaIcon = {
    path: "M -2,0 0,2 2,0 0,-2 -2,0",
    strokeOpacity: 1,
    scale: 2,
    strokeWeight: 1,
    fillOpacity: 1,
    fillColor: "white",
};

export const LineDrawingOptions = {
    strokeColor: "red",
    strokeOpacity: 1,
    strokeWeight: 2,
    editable: false,
    icons: [
        {
            icon: LineIcon,
            offset: "0%",
        },
        {
            icon: LineIcon,
            offset: "100%",
        },
    ],
};

export const AreaDrawingOptions = {
    strokeColor: "blue",
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor: "blue",
    fillOpacity: 0.3,
    editable: false,
    clickable: false,
};

export const crosshairContainerStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    pointerEvents: "auto",
    cursor: "move",
    touchAction: "none",
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
};

export const crosshairStyle = {
    width: "96px",
    height: "96px",
    position: "relative",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};
